import { useLang } from '@/i18n';
import EfBanner from '@elem/ui/ef-banner';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useProductStore } from '../../ProductProvider';

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();
    const usPc = 'https://websiteoss.ecoflow.com/upload/image/1724566389277/aa1.jpg';
    const usH5 = 'https://websiteoss.ecoflow.com/upload/image/1724566389806/aa2.jpg';
    const euPc = 'https://websiteoss.ecoflow.com/upload/image/1724574990594/pc1.jpg';
    const euH5 = 'https://websiteoss.ecoflow.com/upload/image/1724574990240/h5.jpg';
    const ukPc = 'https://websiteoss.ecoflow.com/upload/image/1724574990400/pc2.jpg';
    const ukH5 = 'https://websiteoss.ecoflow.com/upload/image/1724574990240/h5.jpg';
    const imgLocale: any = {
        us: {
            pc: usPc,
            h5: usH5,
        },
        ca: {
            pc: usPc,
            h5: usH5,
        },
        uk: {
            pc: ukPc,
            h5: ukH5,
        },
        eu: {
            pc: euPc,
            h5: euH5,
        },
    };
    const imgA = imgLocale[locale] || imgLocale['eu'];
    const { t } = useLang('theProduct.Banner');
    const itemA = {
        title: t('title'),
        desc: t('desc'),
        pc: imgA.pc,
        h5: imgA.h5,
        btn_text: t('btn'),
        btn_link:
            pageStatus === 'statusA' ? '' : 'https://www.youtube.com/embed/gtxAkmNxMH8?si=MSicapOQhBWL8Dw-&enablejsapi=1&origin=https%3A%2F%2Fwww.ecoflow.com',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA} theme="black" />
        </div>
    );
}
